module.exports = __webpack_public_path__ + "static/media/en.6653d85d.PNG";